import { render } from "./index.vue?vue&type=template&id=7c2dfa25&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=7c2dfa25&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2dfa25"],['__file',"src/views/vab/card/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c2dfa25"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c2dfa25', __exports__)) {
    console.log('reload')
    api.reload('7c2dfa25', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=7c2dfa25&scoped=true", () => {
    console.log('re-render')
    api.rerender('7c2dfa25', render)
  })

}


export default __exports__